import iframeResize from 'iframe-resizer/js/iframeResizer'

const iframe = document.getElementById('risikotooliframe')
const imageDialog = document.getElementById('risikotooldialog')
const imageDialogCloseButton = imageDialog?.querySelector('[data-close]')

const closeImageDialog = () => {
    if (!imageDialog) {
        return
    }

    imageDialog.hidden = true
    imageDialog.classList.remove('is-open')
    imageDialog.setAttribute('aria-hidden', 'true')
}

const openImageDialog = () => {
    if (!imageDialog) {
        return
    }

    imageDialog.hidden = false
    imageDialog.classList.add('is-open')
    imageDialog.setAttribute('aria-hidden', 'false')
}

imageDialogCloseButton?.addEventListener('click', closeImageDialog)
imageDialog?.addEventListener('click', (event) => {
    if (event.target === imageDialog) {
        closeImageDialog()
    }
})

document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && imageDialog && !imageDialog.hidden) {
        closeImageDialog()
    }
})

if (iframe) {
    const nodeId = iframe.closest('.excel-risiko-tool')?.dataset.nodeId

    // When a section changes the iframe content height can change drastically
    // (e.g. the final report page or the short initial page). The resize is
    // reported asynchronously, so a single scroll can be clamped/lost. We scroll
    // immediately and re-apply once the iframe finishes resizing.
    let pendingScrollToTop = false

    const scrollToToolTop = () => {
        const header = document.querySelector('.main-header');
        const headerOffset = header ? header.offsetHeight : 0;
        const top = iframe.getBoundingClientRect().top + window.scrollY - headerOffset;

        window.scrollTo({ top, behavior: 'auto' });
    }

    iframeResize({
        checkOrigin: false,
        heightCalculationMethod: 'lowestElement',
        onResized: () => {
            if (pendingScrollToTop) {
                pendingScrollToTop = false;
                scrollToToolTop();
            }
        }
    }, '#risikotooliframe')

    window.addEventListener('message', function (e) {
        switch (e.data?.type) {
            case 'risikotool-section-changed': {
                pendingScrollToTop = true;
                scrollToToolTop();
                break
            }
            case 'risikotool-open-dialog': {
                document.getElementById('imageDialogTitle').textContent = e.data.data.imageDialogTitle;
                document.getElementById('imageDialogImage').setAttribute('src', e.data.data.imagePath);
                document.getElementById('imageDialogImage').setAttribute('alt', e.data.data.imageAltText);
                document.getElementById('imageDialogCaption').textContent = e.data.data.imageCaption;

                openImageDialog();
                break
            }
            case 'risiko-track-start':
                if (typeof _sz !== 'undefined') {
                    _sz.push(['event', 'RisikoTool', 'Start', nodeId])
                }
                break
            case 'risiko-track-download':
                if (typeof _sz !== 'undefined') {
                    _sz.push(['event', 'RisikoTool', 'Download', nodeId])
                }
                break
        }
    })
}
